module.exports = __webpack_public_path__ + "band_8_son.943336f9.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/child_to_parent/band_8_son.png
// module id = /wqX
// module chunks = 0